import type { Localized } from '../types/content'

export const business = {
  name: 'M&S Multiservices',
  logo: 'https://cdn.magicpatterns.com/uploads/qWkD1fsG9xEqNYLkkSGhEx/Screenshot_2026-09-11_at_4.33.31_PM.png',
  phoneDisplay: '+1 (214) 259-5582',
  phoneHref: 'tel:+12142595582',
  whatsappHref: 'https://wa.me/12142595582?text=Hello%20M%26S%20Multiservices%2C%20I%27d%20like%20a%20free%20estimate.',
  email: 'ms.multiservices2025@gmail.com',
  emailHref: 'mailto:ms.multiservices2025@gmail.com',
  city: 'Dallas, Texas',
  yearsExperience: '10+',
  mapEmbed:
    'https://www.google.com/maps?q=Dallas-Fort%20Worth,%20Texas&z=9&output=embed',
  social: {
    facebook: 'https://facebook.com',
    instagram: 'https://instagram.com',
    youtube: 'https://youtube.com',
  },
}

export const tagline: Localized = {
  en: 'We Improve Your Home, We Transform Your Space',
  es: 'Mejoramos tu hogar, transformamos tu espacio',
}

export const navLinks: { to: string; label: Localized }[] = [
  { to: '/', label: { en: 'Home', es: 'Inicio' } },
  { to: '/services', label: { en: 'Services', es: 'Servicios' } },
  { to: '/gallery', label: { en: 'Gallery', es: 'Galería' } },
  { to: '/about', label: { en: 'About', es: 'Nosotros' } },
  { to: '/contact', label: { en: 'Contact', es: 'Contacto' } },
  { to: '/faq', label: { en: 'FAQ', es: 'Preguntas' } },
]

export const businessHours: { day: Localized; hours: Localized }[] = [
  {
    day: { en: 'Monday – Friday', es: 'Lunes – Viernes' },
    hours: { en: '7:00 AM – 6:00 PM', es: '7:00 AM – 6:00 PM' },
  },
  {
    day: { en: 'Saturday', es: 'Sábado' },
    hours: { en: '8:00 AM – 4:00 PM', es: '8:00 AM – 4:00 PM' },
  },
  {
    day: { en: 'Sunday', es: 'Domingo' },
    hours: { en: 'Closed — emergencies by phone', es: 'Cerrado — emergencias por teléfono' },
  },
]

export const serviceAreas: string[] = [
  'Dallas',
  'Fort Worth',
  'Arlington',
  'Plano',
  'Irving',
  'Garland',
  'Frisco',
  'McKinney',
  'Richardson',
  'Carrollton',
  'Denton',
  'Grand Prairie',
  'Mesquite',
  'Lewisville',
  'Grapevine',
  'Rockwall',
]
